export const saleDropdown=[
    {label:'Ready for sale',value:0},
    {label:'Sold out',value:1},
    {label:'Not for sale',value:2}
]